function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// shim for using process in browser
var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
  throw new Error('setTimeout has not been defined');
}

function defaultClearTimeout() {
  throw new Error('clearTimeout has not been defined');
}

(function () {
  try {
    if (typeof setTimeout === 'function') {
      _assign__("cachedSetTimeout", setTimeout);
    } else {
      _assign__("cachedSetTimeout", _get__("defaultSetTimout"));
    }
  } catch (e) {
    _assign__("cachedSetTimeout", _get__("defaultSetTimout"));
  }

  try {
    if (typeof clearTimeout === 'function') {
      _assign__("cachedClearTimeout", clearTimeout);
    } else {
      _assign__("cachedClearTimeout", _get__("defaultClearTimeout"));
    }
  } catch (e) {
    _assign__("cachedClearTimeout", _get__("defaultClearTimeout"));
  }
})();

function runTimeout(fun) {
  if (_get__("cachedSetTimeout") === setTimeout) {
    //normal enviroments in sane situations
    return setTimeout(fun, 0);
  } // if setTimeout wasn't available but was latter defined


  if ((_get__("cachedSetTimeout") === _get__("defaultSetTimout") || !_get__("cachedSetTimeout")) && setTimeout) {
    _assign__("cachedSetTimeout", setTimeout);

    return setTimeout(fun, 0);
  }

  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return _get__("cachedSetTimeout")(fun, 0);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
      return _get__("cachedSetTimeout").call(null, fun, 0);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
      return _get__("cachedSetTimeout").call(this, fun, 0);
    }
  }
}

function runClearTimeout(marker) {
  if (_get__("cachedClearTimeout") === clearTimeout) {
    //normal enviroments in sane situations
    return clearTimeout(marker);
  } // if clearTimeout wasn't available but was latter defined


  if ((_get__("cachedClearTimeout") === _get__("defaultClearTimeout") || !_get__("cachedClearTimeout")) && clearTimeout) {
    _assign__("cachedClearTimeout", clearTimeout);

    return clearTimeout(marker);
  }

  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return _get__("cachedClearTimeout")(marker);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
      return _get__("cachedClearTimeout").call(null, marker);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
      // Some versions of I.E. have different rules for clearTimeout vs setTimeout
      return _get__("cachedClearTimeout").call(this, marker);
    }
  }
}

var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
  if (!_get__("draining") || !_get__("currentQueue")) {
    return;
  }

  _assign__("draining", false);

  if (_get__("currentQueue").length) {
    _assign__("queue", _get__("currentQueue").concat(_get__("queue")));
  } else {
    _assign__("queueIndex", -1);
  }

  if (_get__("queue").length) {
    _get__("drainQueue")();
  }
}

function drainQueue() {
  if (_get__("draining")) {
    return;
  }

  var timeout = _get__("runTimeout")(_get__("cleanUpNextTick"));

  _assign__("draining", true);

  var len = _get__("queue").length;

  while (len) {
    _assign__("currentQueue", _get__("queue"));

    _assign__("queue", []);

    while (_update_operation__("++", "queueIndex", true) < len) {
      if (_get__("currentQueue")) {
        _get__("currentQueue")[queueIndex].run();
      }
    }

    _assign__("queueIndex", -1);

    len = _get__("queue").length;
  }

  _assign__("currentQueue", null);

  _assign__("draining", false);

  _get__("runClearTimeout")(timeout);
}

_get__("process").nextTick = function (fun) {
  var args = new Array(arguments.length - 1);

  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
  }

  _get__("queue").push(new (_get__("Item"))(fun, args));

  if (_get__("queue").length === 1 && !_get__("draining")) {
    _get__("runTimeout")(_get__("drainQueue"));
  }
}; // v8 likes predictible objects


function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}

_get__("Item").prototype.run = function () {
  this.fun.apply(null, this.array);
};

_get__("process").title = 'browser';
_get__("process").browser = true;
_get__("process").env = {};
_get__("process").argv = [];
_get__("process").version = ''; // empty string to avoid regexp issues

_get__("process").versions = {};

function noop() {}

_get__("process").on = _get__("noop");
_get__("process").addListener = _get__("noop");
_get__("process").once = _get__("noop");
_get__("process").off = _get__("noop");
_get__("process").removeListener = _get__("noop");
_get__("process").removeAllListeners = _get__("noop");
_get__("process").emit = _get__("noop");
_get__("process").prependListener = _get__("noop");
_get__("process").prependOnceListener = _get__("noop");

_get__("process").listeners = function (name) {
  return [];
};

_get__("process").binding = function (name) {
  throw new Error('process.binding is not supported');
};

_get__("process").cwd = function () {
  return '/';
};

_get__("process").chdir = function (dir) {
  throw new Error('process.chdir is not supported');
};

_get__("process").umask = function () {
  return 0;
};

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case "cachedSetTimeout":
      return cachedSetTimeout;

    case "defaultSetTimout":
      return defaultSetTimout;

    case "cachedClearTimeout":
      return cachedClearTimeout;

    case "defaultClearTimeout":
      return defaultClearTimeout;

    case "draining":
      return draining;

    case "currentQueue":
      return currentQueue;

    case "queue":
      return queue;

    case "queueIndex":
      return queueIndex;

    case "drainQueue":
      return drainQueue;

    case "runTimeout":
      return runTimeout;

    case "cleanUpNextTick":
      return cleanUpNextTick;

    case "runClearTimeout":
      return runClearTimeout;

    case "process":
      return process;

    case "Item":
      return Item;

    case "noop":
      return noop;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value) {
  switch (variableName) {
    case "cachedSetTimeout":
      return cachedSetTimeout = _value;

    case "cachedClearTimeout":
      return cachedClearTimeout = _value;

    case "draining":
      return draining = _value;

    case "queue":
      return queue = _value;

    case "queueIndex":
      return queueIndex = _value;

    case "currentQueue":
      return currentQueue = _value;
  }

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (_typeof(variableName) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)["catch"](reset);
    } else {
      reset();
    }

    return result;
  };
}

var _typeOfOriginalExport = _typeof(module.exports);

function addNonEnumerableProperty(name, value) {
  Object.defineProperty(module.exports, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}

if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(module.exports)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}